// ADDED: V2 Service for Criteria-Based Salary Rules
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const maintenanceSalaryCombinationV2Service = {
  getDashboard: async (payload) => {
    return await axios.post(`${domain}/api/MaintenanceSalaryCombinationV2/dashboard`, payload, { headers });
  },
  getById: async (id) => {
    return await axios.get(`${domain}/api/MaintenanceSalaryCombinationV2/${id}`, { headers });
  },
  create: async (payload) => {
    console.log('Final bulkData:', JSON.stringify(payload, null, 2));
    return await axios.post(`${domain}/api/MaintenanceSalaryCombinationV2`, payload, { headers });
  },
  update: async (id, payload) => {
    return await axios.put(`${domain}/api/MaintenanceSalaryCombinationV2/${id}`, payload, { headers });
  }
};

export default maintenanceSalaryCombinationV2Service;